import { render } from "./ContinueApp.vue?vue&type=template&id=000a0284&scoped=true"
import script from "./ContinueApp.vue?vue&type=script&lang=js"
export * from "./ContinueApp.vue?vue&type=script&lang=js"

import "./ContinueApp.vue?vue&type=style&index=0&id=000a0284&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000a0284"]])

export default __exports__